import type { RegistrationUserDataPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import { html } from 'lit';

export const defaultRegistrationUserDataPlugin: RegistrationUserDataPlugin<UserStammdaten> = {
  id: 'registration::user-data::default',
  type: 'registration::user-data',
  render: (stammdatenController: GenericFieldFormController<UserStammdaten>) => html`
    <bh-plugin-generated-form
      placeholder-mode="static-floating"
      .formController=${stammdatenController}
      .blacklist=${['userID', 'institutionID']}
    ></bh-plugin-generated-form>
  `,
};
